import type { SuccessAlert } from './type';

export const successStore = defineStore('successStore', {
  state: (): SuccessStore.SuccessState => {
    return {
      successes: [],
    };
  },
  getters: {
    totalSuccess: (state) => state.successes.length,
    getLatestSuccess: (state) => {
      const latestSuccess = state.successes[state.successes.length - 1];
      if (latestSuccess && typeof latestSuccess.title === 'string') {
        return latestSuccess;
      }
      return null;
    },
  },
  actions: {
    SUCCESSES_RESET() {
      this.successes = [];
    },

    ADD_SUCCESS(success: SuccessAlert) {
      this.successes.push(success);
    },

    REMOVE_SUCCESS(success: SuccessAlert) {
      const index = this.successes.findIndex(
        (currentSuccess) => currentSuccess.title === success.title,
      );

      if (index > -1) {
        this.successes.splice(index, 1);
      }
    },
  },
});

namespace SuccessStore {
  export type SuccessState = {
    successes: SuccessAlert[];
  };
}
